import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { nikola } from "@/data/site";
import { FadeUp } from "@/components/motion/Reveal";
import { Portrait } from "@/components/home/Nikola";
import { Fairness } from "@/components/home/Fairness";
import { CtaBand } from "@/components/home/CtaBand";
import { TerminDialog } from "@/components/TerminDialog";
import { Award } from "lucide-react";

export default function UeberUns() {
  return (
    <>
      <Seo title="Über uns – Fachwissen mit Gesicht" description="Hinter NIVO Garage steht Nikola Mirkovic, Automobil-Mechatroniker EFZ. Sorgfältiges Handwerk, persönlicher Umgang und verständliche Erklärungen in Siebnen (SZ)." />
      <PageHeader eyebrow="Über uns" lines={["Fachwissen", "mit Gesicht."]} />
      <section id="werkstatt" className="pb-16 md:pb-24">
        <div className="container-x grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <FadeUp className="max-w-sm lg:sticky lg:top-28">
              <Portrait />
              <dl className="mt-6 border-t hairline">
                {nikola.facts.map((f) => (
                  <div key={f.y} className="flex gap-6 py-3 border-b hairline" data-testid={`about-fact-${f.y}`}>
                    <dt className="text-[color:var(--ink-3)] mono w-12">{f.y}</dt>
                    <dd>{f.t}</dd>
                  </div>
                ))}
              </dl>
              <div className="mt-8" data-testid="about-education">
                <p className="eyebrow mb-4">Ausbildung &amp; Qualifikationen</p>
                <ul className="space-y-3">
                  {nikola.education.map((e) => (
                    <li key={e.title} className="flex items-start gap-3" data-testid={`about-education-${e.date}`}>
                      <Award className="h-5 w-5 mt-0.5 shrink-0" style={{ color: "var(--violet)" }} aria-hidden="true" />
                      <span>
                        <span className="block font-medium text-[color:var(--ink)] leading-snug">{e.title}</span>
                        <span className="block text-[14px] text-[color:var(--ink-3)] mono">{e.date}</span>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </FadeUp>
          </div>
          <div className="lg:col-span-7 space-y-5">
            <FadeUp><p className="eyebrow">{nikola.name} · {nikola.role} Nivo Garage</p></FadeUp>
            <FadeUp delay={0.05}><h2 className="h-sub text-[color:var(--ink)] max-w-xl" data-testid="about-tagline">{nikola.tagline}</h2></FadeUp>
            {nikola.story.map((p, i) => (
              <FadeUp key={i} delay={0.08 + i * 0.03} className="text-[color:var(--ink-2)] leading-relaxed text-[16px] md:text-[17px]">{p}</FadeUp>
            ))}

            {nikola.chapters.map((c) => (
              <div key={c.title} className="pt-6 space-y-4">
                <FadeUp><h3 className="h-sub text-[color:var(--ink)]">{c.title}</h3></FadeUp>
                {c.paras.map((p, i) => (
                  <FadeUp key={i} delay={0.04 + i * 0.03} className="text-[color:var(--ink-2)] leading-relaxed text-[16px] md:text-[17px]">{p}</FadeUp>
                ))}
              </div>
            ))}

            <FadeUp className="pt-6">
              <p className="font-medium text-[color:var(--ink)]">{nikola.name}</p>
              <p className="text-[color:var(--ink-3)] text-[15px]">{nikola.role} Nivo Garage</p>
            </FadeUp>
            <FadeUp delay={0.1}>
              <TerminDialog testId="about-appointment-button" className="btn-violet mt-2" />
            </FadeUp>
          </div>
        </div>
      </section>
      <Fairness />
      <CtaBand />
    </>
  );
}
